import React from 'react';
import { Link } from 'react-router-dom';
import { SiAppstore, SiGoogleplay } from 'react-icons/si';
import HeroSlider from '../../components/HeroSlider/HeroSlider';
import HomeSplashPopup from '../../components/HomeSplashPopup/HomeSplashPopup';
import HomeFeaturedStory from './HomeFeaturedStory';
import HomeFeaturedDishes from './HomeFeaturedDishes';
import StatsSection from '../../components/StatsSection/StatsSection';
import MealPlanCards from '../../components/MealPlanCards/MealPlanCards';

import aboutFoodImg from '../../assets/images/about-food.png';
import mobileAppImg from '../../assets/images/mobile-app.png';
import plan1MonthImg from '../../assets/images/plan-card-1month.svg';
import plan2MonthImg from '../../assets/images/plan-card-2months.svg';
import plan3MonthImg from '../../assets/images/plan-card-3months.svg';
import nutritionImg from '../../assets/images/nutritious.jpg';

import './Home.css';

const mealPlans = [
  {
    name: '1 MONTH PLAN',
    duration: '30 Days',
    sub: 'Lunch / Dinner (or both)',
    features: [
      'Seamless doorstep delivery',
      'Flexible pause/cancellation',
      'Nominal delivery charges',
    ],
    image: plan1MonthImg,
    tag: null,
  },
  {
    name: '2 MONTHS PLAN',
    duration: '60 Days',
    sub: 'Lunch / Dinner (or both)',
    features: [
      'Seamless doorstep delivery',
      'Flexible pause/cancellation',
      'Free doorstep delivery',
    ],
    image: plan2MonthImg,
    featured: true,
    tag: 'MOST POPULAR',
    savings: 'Save upto 5%',
  },
  {
    name: '3 MONTHS PLAN',
    duration: '90 Days',
    sub: 'Lunch / Dinner (or both)',
    features: [
      'Seamless doorstep delivery',
      'Flexible pause/cancellation',
      'Free delivery + priority support',
    ],
    image: plan3MonthImg,
    tag: 'BEST VALUE',
    savings: 'Save upto 10%',
  },
];

const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.digirasa.client';
const APP_STORE_URL = 'https://apps.apple.com/in/app/digirasa/id6736368836';
const PLAY_STORE_QR_URL = `https://api.qrserver.com/v1/create-qr-code/?size=160x160&data=${encodeURIComponent(PLAY_STORE_URL)}`;
const APP_STORE_QR_URL = `https://api.qrserver.com/v1/create-qr-code/?size=160x160&data=${encodeURIComponent(APP_STORE_URL)}`;

const Home = () => {
  return (
    <div className="home">
      {/* Hero Slider */}
      <HeroSlider />
      <HomeSplashPopup />

      <HomeFeaturedStory />
      <HomeFeaturedDishes />


      {/* About/Nutrition Section */}
      <section className="nutrition-section">
        <div className="container">
          <div className="nutrition-section__grid">
            <div className="nutrition-section__content">
              <span className="section-tag">About Our Food</span>
              <h2 className="section-title">
                NUTRITION
                <br />
                <span>REDEFINED</span>
              </h2>
              <p className="section-para">
                Our food offers a perfect blend of nutrition and great taste, combining traditional
                cuisine with a modern touch. We prepare healthy, organic meals tailored to the
                specific dietary needs of children, the elderly, and hospital patients and staff.
              </p>
              <p className="section-para">
                Crafted with the finest, healthiest ingredients, our meals are designed to boost
                health and immunity while meeting individual preferences and nutritional
                requirements.
              </p>
              <Link
                to="/our-menu"
                className="btn-primary"
                style={{ marginTop: '24px', display: 'inline-block' }}
              >
                ORDER NOW
              </Link>
            </div>
            <div className="nutrition-section__image">
              <img src={aboutFoodImg} alt="Nutrition Redefined" />
            </div>
          </div>
        </div>
      </section>

      <StatsSection />

      {/* Favorite Food */}
      <section className="favorite-food">
        <div className="container">
          <div className="favorite-food__content">
            <span className="section-tag">Popular Dishes</span>
            <h2 className="section-title">
              ORDER YOUR
              <br />
              <span>FAVORITE FOOD</span>
            </h2>
            <div className="favorite-food__price-badge">
              <span className="favorite-food__price">Rs. 276/-</span>
            </div>
            <ul className="favorite-food__dishes">
              <li>South Indian Executive Meal</li>
              <li>North Indian Executive Meal</li>
            </ul>
            <a
              href="https://play.google.com/store/apps/details?id=com.digirasa.client"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary"
              style={{ display: 'inline-block', alignSelf: 'flex-start' }}
            >
              ORDER NOW
            </a>
          </div>
          <div className="favorite-food__image">
            <img src={nutritionImg} alt="Favorite Food" />
          </div>
        </div>
      </section>

      {/* Meal Plans */}
      <section className="meal-plans">
        <div className="container">
          <div className="section-header">
            <span className="section-tag">Meal Plans</span>
            <h2 className="section-title">
              SUBSCRIBE <span>NOW</span>
            </h2>
            <p className="section-desc section-para">
              Healthy Meal Plans — Flexible subscriptions designed for individuals, families, and
              organizations.
            </p>
          </div>
          <div className="meal-plans__grid">
            <MealPlanCards
              plans={mealPlans}
              getSubtitle={(plan) => plan.sub}
              renderCta={(plan) => (
                <Link
                  to="/meal-plans#subscription-builder"
                  className={plan.featured ? 'btn-primary' : 'btn-secondary'}
                >
                  SUBSCRIBE NOW
                </Link>
              )}
            />
          </div>
        </div>
      </section>

      {/* App Download */}
      <section className="app-section" id="APPSTORE">
        <div className="container">
          <div className="app-section__grid">
            <div className="app-section__content">
              <span className="section-tag">For more offers &amp; Discounts</span>
              <h2 className="section-title">
                Download Our APP
                <br />
                Order Online
              </h2>
              <p className="section-para">
                We are a trusted nutritious food brand with 2+ years of experience, delivering
                high-quality traditional foods with a focus on health and authenticity.
              </p>
              <div className="app-section__actions">
                <div className="app-section__badges">
                  <a
                    href="https://play.google.com/store/apps/details?id=com.digirasa.client"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="app-section__store-pill"
                  >
                    <SiGoogleplay className="app-section__store-icon" />
                    <span className="app-section__store-text">
                      <span className="app-section__store-kicker">GET IT ON</span>
                      <span className="app-section__store-name">Google Play</span>
                    </span>
                  </a>
                  <a
                    href="https://apps.apple.com/in/app/digirasa/id6736368836"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="app-section__store-pill"
                  >
                    <SiAppstore className="app-section__store-icon" />
                    <span className="app-section__store-text">
                      <span className="app-section__store-kicker">Download on the</span>
                      <span className="app-section__store-name">App Store</span>
                    </span>
                  </a>
                </div>
                <div className="app-section__qr-list">
                  <a
                    href={PLAY_STORE_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="app-section__qr"
                    aria-label="Scan QR code for Google Play"
                  >
                    <img src={PLAY_STORE_QR_URL} alt="Digirasa Google Play QR code" />
                    <span>Scan for Google Play</span>
                  </a>
                  <a
                    href={APP_STORE_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="app-section__qr"
                    aria-label="Scan QR code for App Store"
                  >
                    <img src={APP_STORE_QR_URL} alt="Digirasa App Store QR code" />
                    <span>Scan for App Store</span>
                  </a>
                </div>
              </div>
              <p className="app-section__order-text">
                * Free delivery within 2kms radius from the kitchen
              </p>
            </div>
            <div className="app-section__image">
              <img src={mobileAppImg} alt="Digirasa Mobile App" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
